import { render } from "./Objektname.vue?vue&type=template&id=424c2b3e"
import script from "./Objektname.vue?vue&type=script&lang=js"
export * from "./Objektname.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__